import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import Slot from '../Slot';
import useStyles from './styles';

const Loading = ({ columns }) => {
  const classes = useStyles();
  const columnsArr = Array.from({ length: columns }, (v, index) => index);
  return (
    <Box className={classes.container}>
      <Box className="schedule-slot-controls-container">
        <Box className="schedule-slot-controls-content">
          <Box px={1}>
            <Skeleton variant="circle" width={24} height={24} />
          </Box>
          <Box px={1}>
            <Skeleton variant="circle" width={24} height={24} />
          </Box>
        </Box>
      </Box>
      <Box className="swiper-header-wrapper">
        <Box className="swiper-header-container">
          {columnsArr.map(col => (
            <Box key={col} className="swiper-header-column-container">
              <Box className="swiper-header-column-content">
                <Slot label loading />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
